module.exports = "#mainContent {\n  padding-top: 10px; }\n\n#typeAheadTemplate {\n  overflow: hidden;\n  font-size: small; }\n"